import createAxiosInstance from 'src/utils/createAxiosInstance';
import { CLIENT_PORTAL_API_URL, DATA_AUDIT_API_URL } from 'src/utils/constants';

export const clientPortalApi = createAxiosInstance(CLIENT_PORTAL_API_URL);
export const dataAuditApi = createAxiosInstance(DATA_AUDIT_API_URL);
